// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1Nl7z","fileBtn":"File_fileBtn__1hu-k","closeBtn":"File_closeBtn__3l90Y","fileSelected":"File_fileSelected__7xBct","disabled":"File_disabled__l6iM7"};